namespace GeniuzPOS.Purchase {
    export interface LookupCnforCnrtvRow {
        SysDocNo?: string;
        SupplierId?: string;
    }

    export namespace LookupCnforCnrtvRow {
        export const idProperty = 'SysDocNo';
        export const nameProperty = 'SysDocNo';
        export const localTextPrefix = 'Purchase.LookupCnforCnrtv';
        export const lookupKey = 'Purchase.LookupCnforCnrtv';

        export function getLookup(): Q.Lookup<LookupCnforCnrtvRow> {
            return Q.getLookup<LookupCnforCnrtvRow>('Purchase.LookupCnforCnrtv');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            SysDocNo = "SysDocNo",
            SupplierId = "SupplierId"
        }
    }
}
